import {format, isToday, isYesterday, parseISO} from 'date-fns';
// 格式化日期标签
export function formatDateLabel(dateStr) {
    let date;
    try {
        // 支持 ISO 字符串、2025-04-07、2025-04-07T10:20:00 等格式
        date = parseISO(dateStr);
        if (isNaN(date)) {
            date = new Date(dateStr);
        }
    }
    catch (e) {
        return ''; // 无效日期返回空
    }
    if (isToday(date)) {
        return '今天';
    }
    if (isYesterday(date)) {
        return '昨天';
    }
    return format(date, 'yyyy/MM/dd');
}


// 格式化图片数据
export const formatRecordData = record => {
    return {
        taskId: record.taskId,
        recordId: record.recordId,
        url: record.url || '',
        checked: record.checked || false,

        // 模板编辑用数据
        width: record.width || 0,
        height: record.height || 0,
        templateId: record.templateId || '',
        editorParams: record.editorParams || ''
    };
};

// 从ext中获取图片比例相关数据
const getRatioData = (type, extData) => {
    let ratioList = [];
    if (type === 'BACKGROUND_V2') {
        let ratio = extData.intelFormData?.sizeControl?.value?.ratio || '';
        ratioList.push(ratio);
    }
    // 模板图可能有多个尺寸
    else if (type === 'NEW_TEMPLATE_GEN_IMAGE') {
        let templateGroup = extData.designFormData?.templateGroup;
        let chooseMyTpl = templateGroup?.template?.chooseMyTpl;
        let originTemplateList = templateGroup?.template?.originTemplateList;
        if (chooseMyTpl) {
            chooseMyTpl.forEach(item => {
                let ratio = item.ratioText || '';
                ratioList.push(ratio);
            });
        }
        if (originTemplateList) {
            originTemplateList.forEach(item => {
                let ratio = item.ratio || templateGroup?.sizeControl?.value?.ratio || '';
                ratioList.push(ratio);
            });
        }
    }
    else if (type === 'SIMPLE_EXPAND_TOOL') {
        let extendFormData = extData.extendFormData;
        if (!extendFormData) {
            // 没数据的时候使用自定义尺寸
            return [''];
        }

        if (extendFormData.sizeTypeValue === 'choose') {
            ratioList.push(extendFormData.sizeValue);
        }
        else {
            // 自定义尺寸
            ratioList.push('');
        }
    }
    // 裁剪默认是自定义尺寸
    else if (type === 'SIMPLE_CUT_TOOL') {
        ratioList.push('');
    }
    return ratioList;
};
// 格式化数据
export const formatTaskData = data => {
    let _data = JSON.parse(JSON.stringify(data));
    // 从每一项中汇总尺寸提示字段
    let ratioList = [];
    let ratioLabel = '';
    let referPic = null;
    let creativeStyle = null;

    let ext = _data.ext || '{}';
    let extData = JSON.parse(ext);
    let imageGenerateType = _data.imageGenerateType;
    ratioList = getRatioData(imageGenerateType, extData);
    ratioList = [...new Set(ratioList)];
    // 尺寸为空时代表不是标准尺寸
    if (ratioList.findIndex(item => item === '') > -1) {
        ratioLabel = '自定义尺寸';
    }
    else if (ratioList.length > 1) {
        ratioLabel = '混合尺寸';
    }
    else {
        ratioLabel = ratioList[0];
    }

    let _referPic = extData.intelFormData?.referPic?.image?.[0];
    let _creativeStyle = extData.intelFormData?.creativeStyle?.image?.[0];
    // 提取参考图
    if (_referPic?.type?.[0]?.checked) {
        referPic = {
            tip: '参考图',
            url: _referPic.url,
            label: '参考' + _referPic.type[0].label
        };
    }
    // 提取创意风格 （与参考图互斥）
    else if (_creativeStyle?.type?.[0]?.useStyleModel) {
        creativeStyle = {
            tip: '创意风格',
            url: _creativeStyle.url,
            label: _creativeStyle.type[0].label
        };
    }
    // 没有图片记录时，根据生成数量补全占位图
    let typeMap = {
        BACKGROUND_V2: 'intelForm',
        NEW_TEMPLATE_GEN_IMAGE: 'designForm',
        SIMPLE_EXPAND_TOOL: 'extendForm',
        SIMPLE_CUT_TOOL: 'cutoutForm'
    };
    // 生成中的任务，补全图片记录
    // taskStatus不准确（后端反馈抠图扩图没改成异步，无法判断生成状态），所以这里用records的长度来判断是否补全图片记录
    let targetCount = extData.targetCountData?.[typeMap[_data.imageGenerateType]]?.targetCount || 1;
    let records = _data.records || [];
    if (records.length < targetCount && _data.taskStatus === 1) {
        _data.records = records.concat(
            Array.from({
                length: targetCount - records.length
            }, (_, i) => ({
                recordId: i
            }))
        );
    }
    return {
        taskId: _data.taskId, // 任务ID
        status: _data.taskStatus, // 任务生成状态
        // 图片生成类型 BACKGROUND_V2（底图）、NEW_TEMPLATE_GEN_IMAGE（模板图）、SIMPLE_CUT_TOOL（抠图)、SIMPLE_EXPAND_TOOL(扩图)
        imageGenerateType: _data.imageGenerateType,
        prompt: extData.intelFormData?.bgControl?.value?.aiPrompt
            || extData.basePrompt || '', // 提示词
        createTime: _data.queryTime || '', // 创建时间
        referPic, // 参考图
        creativeStyle, // 创意风格
        ratioList, // 包含的所有尺寸 （历史原因，单个任务不包含具体比例，只能从整体任务中判断是否有多个比例）
        ratioLabel, // 尺寸标签
        isCollapsed: _data.isCollapsed || false, // 是否折叠任务
        ext,
        records: _data.records?.map(formatRecordData) || []
    };
};